import React, { Fragment, useContext, useEffect } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { GenerateQuestion } from "../question-generator";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import susenergyimg from "../../img/SustinableEnergy.png";
import * as questionTypes from "../question-types";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Checkbox,
} from "@material-ui/core/";
import DataContext from "../../DataContext";

async function putData(url: string, data = {}): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}
interface IProps {
  data: CarbonTempSections;
  styles: EnvTempStyles;
  addRemoveCompletion: (section: string, amount: number) => void;
  tabName: string;
  refreshData: () => void;
}

export const GenericCarbonTempAccordion: React.FC<IProps> = (props: IProps) => {
  const context = useContext(DataContext);

  const styles = {
    summ_1st: {
      background: props.styles.themeBackground,
      // outline: "#c1d300 2px solid",
      color: props.styles.color,
      marginTop: "5px",
    },
    summ_2nd: {
      background: props.styles.themeItemBackground,
      color: props.styles.color,
      marginTop: "0px",
      borderRadius: "15px",
      //   width: "100%",
    },
    check_box: {
      color: props.styles.themeItemBackground,
      marginTop: "0px",
    },
    check_radio: {
      color: props.styles.color,
      marginTop: "0px",
    },
    button: {
      background: props.styles.themeItemBackground,
      color: props.styles.color,
      marginTop: "10px",
      width: "150px",
    },
    detail_1st: {
      padding: "10px 0px",
      // border: "black solid 2px",
    },
    accord_2nd: {
      boxShadow: "none",
      width: "100%",
    },
  };
  const [answers, setAnswers] = React.useState<{
    [questionId: string]: { choice: string; answer: string };
  }>({});
  function putAnswerCallback(id: number, choice: string, answer: string) {
    const existingAnswers = answers;
    existingAnswers[id.toString()] = { choice: choice, answer: answer };
    setAnswers(existingAnswers);
    putData("https://greencityapi-new.absolarlab.com/api/Answer/carbon/" + id, {
      choice: choice,
      answer: answer,
      user_id: context.userId,
      city_council_id: 0,
      year: 2021,
    }).then(() => {
      props.refreshData();
    });
  }
  // const perSection = 100 / Object.keys(props.data).length;
  return (
    <Fragment>
      {Object.keys(props.data.carbonSubThemes).map((section: string) => {
        return (
          <Accordion key={section} style={{ boxShadow: "none" }}>
            <AccordionSummary
              style={styles.summ_1st}
              expandIcon={<ExpandMoreIcon style={styles.check_radio} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <img
                src={props.data.carbonSubThemes[section].img}
                style={{ width: "45px" }}
              />
              <p className="heading_1">{section}</p>
            </AccordionSummary>
            {props.data.carbonSubThemes[section].questions.map(
              (questionData: Question) => {
                return (
                  <GenerateQuestion
                    key={questionData.id}
                    question={questionData.question}
                    help={questionData.help}
                    type={questionData.type}
                    choices={questionData.choices}
                    id={questionData.id}
                    putAnswerCallback={putAnswerCallback}
                    carbonQuestion={true}
                    orgInfoQuestion={false}
                    index={0}
                  />
                );
              }
            )}
          </Accordion>
        );
      })}
    </Fragment>
  );
};
